import { createStore } from 'effector';
import { type PayinTraderFilters } from '~/entities/payin';
import { setTradersFilter } from './event';

export const $tradersFilter = createStore<PayinTraderFilters>({}).on(setTradersFilter, (src, payload) => ({
    ...src,
    ...payload,
}));
